import { useCallback, useState } from "react";
import { Loader2, LogOut } from "lucide-react";
import { toast } from "sonner";
import { http, formatError } from "@/lib/site";
import { Logo } from "@/components/site/Logo";
import { LeadsTab } from "@/components/admin/LeadsTab";
import { TestimonialsTab } from "@/components/admin/TestimonialsTab";
import { TOKEN_KEY } from "@/components/admin/auth";

const Login = ({ onOk }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await http.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      onOk();
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F7F9] px-4">
      <form onSubmit={submit} className="w-full max-w-md rounded-2xl border border-[#E3EAEF] bg-white p-8" data-testid="admin-login-form">
        <Logo />
        <h1 className="mt-8 text-[28px] font-extrabold text-[#0B3C5D]">Panel de contactos</h1>
        <div className="mt-6 space-y-4">
          <input className="field" type="email" required placeholder="Correo" aria-label="Correo" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
          <input className="field" type="password" required placeholder="Clave" aria-label="Clave" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
        </div>
        <button disabled={loading} className="mt-6 inline-flex min-h-[56px] w-full items-center justify-center rounded-xl bg-[#0B3C5D] text-[18px] font-bold text-white" data-testid="admin-login-submit">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Entrar"}
        </button>
      </form>
    </div>
  );
};

export default function AdminPanel() {
  const [authed, setAuthed] = useState(!!localStorage.getItem(TOKEN_KEY));
  const [tab, setTab] = useState("leads");
  const logout = useCallback(() => { localStorage.removeItem(TOKEN_KEY); setAuthed(false); }, []);
  if (!authed) return <Login onOk={() => setAuthed(true)} />;

  return (
    <div className="min-h-screen bg-[#F4F7F9]">
      <header className="bg-[#0B3C5D]">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
          <Logo light />
          <button onClick={logout} className="inline-flex items-center gap-2 text-[16px] font-semibold text-white" data-testid="admin-logout-btn"><LogOut className="h-5 w-5" /> Salir</button>
        </div>
      </header>
      <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
        <div className="mb-8 inline-flex rounded-xl bg-white p-1.5 shadow-sm" role="tablist">
          {[["leads", "Contactos"], ["testimonios", "Testimonios"]].map(([k, v]) => (
            <button key={k} role="tab" aria-selected={tab === k} onClick={() => setTab(k)} data-testid={`admin-tab-${k}`}
              className={`min-h-[44px] rounded-lg px-5 text-[16px] font-bold ${tab === k ? "bg-[#0B3C5D] text-white" : "text-[#0B3C5D]"}`}>{v}</button>
          ))}
        </div>
        {tab === "leads" ? <LeadsTab onLogout={logout} /> : <TestimonialsTab onLogout={logout} />}
      </div>
    </div>
  );
}
